import { CustomInput } from "features/CenterContent/shared/operationalInformation/components/CustomInput";
import { FC } from "react";
import { useLanguagesForDropsRole } from "shared/hooks/useLanguagesForDropsRole";

type StationPersonProps = {};

export const StationPerson: FC<StationPersonProps> = () => {
  const languages = useLanguagesForDropsRole();
  return (
    <>
      {languages.map((language) => (
        <CustomInput
          key={language}
          language={language}
          customFormField="stationForm.personDescription"
        />
      ))}
    </>
  );
};
